import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { useEffect } from "react";
import { DataTable, Grid, Paper, numeral, setLocale, makeStyles, Typography } from "../../../";
var useStyles = makeStyles(function (theme) {
  var _ref;

  return _ref = {
    header: {
      "justify-content": "space-between"
    },
    card: {
      minHeight: "200px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    content: {
      width: "40%",
      "text-align": "center",
      margin: "20px"
    },
    charts: {
      display: "flex",
      "justify-content": "space-evenly",
      padding: "25px"
    },
    fcolumn: {
      "flex-direction": "column",
      "min-width": "300px"
    }
  }, _defineProperty(_ref, "card", {
    minHeight: "200px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }), _defineProperty(_ref, "content", {
    width: "80%",
    "text-align": "center",
    margin: "20px"
  }), _defineProperty(_ref, "box", {
    display: "flex",
    "align-items": "center",
    "border-radius": "4px",
    border: "1px solid #7d7d7d"
  }), _ref;
});

var Dashboard = function Dashboard(_ref2) {
  var data = _ref2.data,
      options = _ref2.options,
      language = _ref2.language,
      translation = _ref2.translation,
      numOpportunities = _ref2.numOpportunities,
      totalBudget = _ref2.totalBudget,
      tasks = _ref2.tasks,
      locale = _ref2.locale,
      props = _objectWithoutProperties(_ref2, ["data", "options", "language", "translation", "numOpportunities", "totalBudget", "tasks", "locale"]);

  var classes = useStyles();
  useEffect(function () {
    setLocale(locale);
  }, [locale]);
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 5,
    className: classes.charts
  }, /*#__PURE__*/React.createElement("div", {
    className: [classes.charts, classes.fcolumn].join(" ")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      padding: "10px"
    }
  }, translation ? translation.cards.open_opportunities.title : "Open opportunities"), /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.content,
    variant: "h5"
  }, numOpportunities))), /*#__PURE__*/React.createElement("div", {
    className: [classes.charts, classes.fcolumn].join(" ")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    style: {
      padding: "10px"
    }
  }, translation ? translation.cards.total_budget.title : "Estimated value open opportunities v"), /*#__PURE__*/React.createElement("div", {
    className: classes.box
  }, /*#__PURE__*/React.createElement(Typography, {
    className: classes.content,
    variant: "h5"
  }, totalBudget && numeral(totalBudget).format("0,0[.]00 $"))))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    style: {
      marginTop: "64px"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_tasks",
    type: "tasks",
    options: options,
    data: tasks,
    translation: translation ? translation.datatables.tasks : null
  }))));
};

export default Dashboard;